import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-df5615f2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GoodList = _resolveComponent("GoodList");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_GoodList, {
    goods: _ctx.data.goods,
    ref: _ctx.bindRef
  }, null, 8, ["goods"])]), _hoisted_2], 64);
}